import MarkdownIt from 'markdown-it'

// Note: We start by disabling everything, then we only enable the Markdown features we want
const md = new MarkdownIt('zero', { breaks: true })
md.enable(['text', 'newline', 'emphasis', 'link', 'list', 'blockquote'])
export default md
